import { useMemo } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ProductBrandProductBrandReadModel } from '@r/api/generated/client.schemas.ts';
import { Button } from '@ui/button.tsx';

/** Colonnes du tableau des marques d'une boutique custom. */
export function useCustomShopBrandColumns(
  onEdit: (brand: ProductBrandProductBrandReadModel) => void
): ColumnDef<ProductBrandProductBrandReadModel>[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        accessorKey: 'id',
        header: t('admin.shops.brands.column.id')
      },
      {
        accessorKey: 'name',
        header: t('admin.shops.brands.column.name')
      },
      {
        id: 'search',
        accessorFn: (brand) => brand.name,
        enableSorting: false,
        enableHiding: false
      },
      {
        id: 'actions',
        header: '',
        cell: ({ row }) => (
          <div className="flex justify-end">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              aria-label={t('admin.shops.brands.action.edit.aria', {
                brandName: row.original.name
              })}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original);
              }}
            >
              <Pencil className="size-4" />
            </Button>
          </div>
        )
      }
    ],
    [onEdit, t]
  );
}
